'use strict';

angular.module('internal.inspections')
    .controller('InternalInspections', ['$scope', 'IPVisits', '$rootScope', 'Resource', 'Cache', 'IPStatuses', 'IPInspections', '$uibModal', '$state', 'Enterprise', function ($scope, IPVisits, $rootScope, Resource, Cache, IPStatuses, IPInspections, $uibModal, $state, Enterprise) {
        $scope.loading = true;
        $scope.months = Resource.months();
        $scope.bulkActionItems = [];
        $scope.listParams = {
            currentPage: 0,
            numPerPage: 10
        }
        $scope.enterprise = $rootScope.enterprise;
        $scope.messages = [];
        $scope.isInspector = ($rootScope.userAccount.inspector_id && $rootScope.userAccount.inspector_id != null) ? true : false;

        if ($rootScope.enterprise !== null && $rootScope.enterprise.entities.length === 0) {
            Enterprise.get().then(function (enterprise) {
                $rootScope.enterprise = enterprise;
                $scope.inspectionColumns[0].label = $rootScope.enterprise.serviceLabels['SERVICE'] + '/' + $rootScope.enterprise.vehicleLabels['VEHICLE'];
            });
        }

        IPStatuses.get().then(function (statuses) {
            $scope.statuses = statuses;
        })

        IPVisits.getYears().then(function (years) {
            $scope.years = years;
        })

        $scope.getVisits = function (month, year) {
            $scope.loading = true;

            IPVisits.getList(month, year).then(function (visits) {
                if (month == $scope.month && year == $scope.year) {
                    $scope.visits = visits;
                    $scope.loading = false;
                }
            });
        }

        Cache.getState('list').then(function (state) {
            if (state != null) {
                $scope.sortBy = state.sortBy;
                $scope.reverse = state.reverse;
                $scope.search = state.search;
                $scope.listParams.currentPage = state.currentPage;
                $scope.listParams.numPerPage = state.numPerPage;
                $scope.status = state.status;
                $scope.inspector = state.inspector;
                $scope.month = state.month;
                $scope.year = state.year;
            }
            else {
                $scope.month = new Date().getMonth();
                $scope.year = new Date().getFullYear();
                $scope.listParams.currentPage = 0;
                $scope.listParams.numPerPage = 10;
            }

            $scope.getVisits($scope.month, $scope.year);
        })

        $scope.cacheList = function () {
            var state = {
                sortBy: $scope.sortBy,
                reverse: $scope.reverse,
                search: $scope.search,
                currentPage: $scope.listParams.currentPage,
                numPerPage: $scope.listParams.numPerPage,
                status: $scope.status,
                inspector: $scope.inspector,
                month: $scope.month,
                year: $scope.year
            }

            Cache.setState('list', state);
        }

        $scope.$watch('search + status + inspector + month + year', function (old, newie) {
            if (old != newie) {
                $scope.listParams.currentPage = 0;
                $scope.cacheList();
            }
        });

        $scope.$watch('listParams.currentPage + listParams.numPerPage + sortBy + reverse', function (old, newie) {
            if (old != newie) {
                $scope.cacheList();
            }
        })

        $scope.clear = function () {
            $scope.search = '';
            $scope.listParams.currentPage = 0;
            $scope.month = new Date().getMonth();
            $scope.year = new Date().getFullYear();
            $scope.status = null;
            $scope.inspector = null;
            $scope.cacheList();
            $scope.getVisits($scope.month, $scope.year)
        }

        $scope.checkAllInspections = function (event, checkAll, visits) {
            event.stopImmediatePropagation();
            visits.forEach(function (visit) {
                visit.bulkActionItems = [];
                visit.inspections.forEach(function (inspection) {
                    inspection.inBulkApply = checkAll;
                    if (checkAll) {
                        visit.bulkActionItems.push(inspection.id);
                    }
                })
            })
        }

        $scope.setStatus = function (bulkApply, status) {
            if (status != null) {
                var bulkActionItems = [];
                $scope.visits.forEach(function (visit) {
                    if (visit.bulkActionItems != null) {
                        bulkActionItems = bulkActionItems.concat(visit.bulkActionItems);
                    }
                })
                if (bulkActionItems.length > 0) {
                    IPInspections.bulkAction(bulkActionItems, status, 'status').then(function () {
                        bulkApply.isOpen = false;
                        $scope.getVisits($scope.month, $scope.year);
                    })
                }
            }
        }

        $scope.setInspector = function (bulkApply) {
            if (bulkApply.newInspector != null) {
                var bulkActionItems = [];
                $scope.visits.forEach(function (visit) {
                    if (visit.bulkActionItems != null) {
                        bulkActionItems = bulkActionItems.concat(visit.bulkActionItems);
                    }
                })
                if (bulkActionItems.length > 0) {
                    IPInspections.bulkAction(bulkActionItems, bulkApply.newInspector.id, 'inspector').then(function () {
                        bulkApply.isOpen = false;
                        $scope.getVisits($scope.month, $scope.year);
                    })
                }
            }
        }

        $scope.openSpotCheckModal = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'templates/inspection-spot-check-modal/inspection-spot-check-modal.html',
                controller: 'InspectionSpotCheckModalController',
                resolve: {
                }
            }).result.then(function (result) {
                //false if closed normally
                if (result != null && result != false) {
                    $state.go('internal.inspecting.inspection.details', { id: result })
                } else if (result == null){
                    $scope.messages.push('Creating spot check inspection failed.');
                }

            });
        };

        $scope.inspectionColumns = [
            {
                label: $rootScope.enterprise.serviceLabels['SERVICE'] + '/' + $rootScope.enterprise.vehicleLabels['VEHICLE'],
                field: 'name',
                link: {
                    state: 'internal.inspecting.inspection.details',
                    params: [
                        {
                            name: 'id',
                            field: 'id'
                        },
                        {
                            name: 'inspection',
                            field: ''
                        }
                    ]
                },
                document: {
                    id: 'checklist.document.id',
                    code: 'checklist.document.code',
                    url: $rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument'
                },
                info: [
                    {
                        label: 'Unit Number',
                        field: 'vehicle.unit_number'
                    },
                    {
                        label: 'Call Sign',
                        field: 'vehicle.call_sign'
                    }
                ]
            },
            {
                label: 'Number',
                field: 'number'
            },
            {
                label: 'Inspector',
                field: 'inspector_show'
            },
            {
                label: 'Status',
                field: 'status.name'
            },
            {
                label: '',
                field: 'checklist.deficiencies_fail_show',
                type: 'deficiency_total'
            }
        ]
    }])
    ;